<!-- Modal -->
<div>
  <div class="">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h5 id="upper" class="modal-title">Planification Indicateurs</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        <div class="container-fluid">
          <div class="row">
            <!-- Indicateur Information -->
            <div class="col-md-12">
              <div class="card mb-4">
                <div class="container mb-3 text-left">
                  <h6 id="upper" class="mb-4 mt-4 text-center">Informations de l'indicateur</h6>
                  <div class="row mb-3">
                    <div class="col-md-6 text-left">
                      <h6 id="dash">Libellé :</h6>
                    </div>
                    <div class="col-md-6 text-right">
                      <h6 id="dash"><strong>{{items.libelle}}</strong></h6>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-md-6 text-left">
                      <h6 id="dash">Valeur de référence :</h6>
                    </div>
                    <div class="col-md-6 text-right">
                      <h6 id="dash"><strong>{{items.valeur_reference}}</strong></h6>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-md-6 text-left">
                      <h6 id="dash">Source de vérification :</h6>
                    </div>
                    <div class="col-md-6 text-right">
                      <h6 id="dash"><strong>{{items.source_verification}}</strong></h6>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-md-6 text-left">
                      <h6 id="dash">Programmes :</h6>
                    </div>
                    <div class="col-md-6 text-right">
                      <h6 id="dash"><strong>{{items.programme?.libelle}}</strong></h6>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Formulaire de Planification -->
              <div class="card">
                <div class="container mb-3 text-left">
                  <h6 class="mb-4 mt-4 text-center">Planifier un Indicateur</h6>
                  <form>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group mb-3">
                          <label for="annee">Année <span class="text-danger">*</span></label>
                          <select name="annee" [(ngModel)]="planification.annee" id="annee" class="form-select"
                            [class.is-invalid]="submitted && !planification.annee">
                            <option [value]="null">Sélectionner une année</option>
                            <option *ngFor="let annee of annees" [value]="annee" [disabled]="hasTargetForYear(annee)">
                              {{annee}} {{hasTargetForYear(annee) ? '(Déjà planifié)' : ''}}
                            </option>
                          </select>
                          <div class="invalid-feedback" *ngIf="submitted && !planification.annee">
                            Veuillez sélectionner l'année
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group mb-3">
                          <label for="valeur_cible">Valeur cible <span class="text-danger">*</span></label>
                          <input type="number" class="form-control" id="valeur_cible"
                            [(ngModel)]="planification.valeur_cible" name="valeur_cible"
                            [class.is-invalid]="submitted && (planification.valeur_cible === null || planification.valeur_cible === undefined)"
                            placeholder="Entrez la valeur cible">
                          <div class="invalid-feedback" 
                               *ngIf="submitted && (planification.valeur_cible === null || planification.valeur_cible === undefined)">
                            Veuillez saisir la valeur cible
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-secondary" (click)="closeModal()">
                        <i class="pi pi-times" style="color: white"></i> Annuler
                      </button>
                      <button type="button" class="btn btn-primary" (click)="savePlanification()">
                        <i class="pi pi-save" style="color: white"></i> Planifier
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
